import React from "react";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";

const AttendanceProcedureModal = ({open, content, onOpenChange, onCopy}) => (
    <Modal open={open} setOpen={onOpenChange} title="Modelo para preenchimento" className="w-7/12">
        <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
            <div className="max-h-[60vh] overflow-auto rounded-md border border-gray-200 p-3 text-sm text-gray-600 whitespace-pre-wrap">
                {content}
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onCopy}>Copiar</Button>
        </Modal.Footer>
    </Modal>
);

export default AttendanceProcedureModal;
